import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { canReach } from '../../godMode/hidden';

/**
 * En God Mode, une route directe vers un écran masqué (adresse tapée, favori,
 * lien d'une carte) renvoie vers /dashboard avant que la page ne monte et ne
 * déclenche des appels que le serveur refuserait.
 */
export default function GodModeRouteGuard({ children }) {
  const { pathname } = useLocation();
  if (!canReach(pathname)) return <Navigate to="/dashboard" replace />;
  return children ?? <Outlet />;
}
